<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineTemplate.read")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <AveineWineTemplateSheet :APIbaseURL="APIbaseURL" :wineTemplate="wineTemplate" :labelChangePerms="true" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineWineTemplateSheet } from 'aveine-wine';
import { WineTemplate, Wine } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      wineTemplate: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Read',
  components: {
    AveineWineTemplateSheet
  },
  async created() {
    try {
      await WineTemplate.api().get(`wine-templates/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
        params: {
          include:
            'grapes-composes-wine-template.grape.grape-variety,' +
            'wines.wine-labels,' +
            'primary-wine-label,' +
            'appellation,' +
            'region,' +
            'country,' +
            'domain.region.country',
        }
      });

      await Wine.api().get(`wine-templates/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
        params: {
          include:
            'grapes-composes-wine-template.grape.grape-variety,' +
            'wines.wine-labels,' +
            'appellation,' +
            'region,' +
            'country,' +
            'domain.region.country',
        }
      });

      this.wineTemplate = await WineTemplate.query().whereId(this.$route.params.id).withAllRecursive().first();

      this.wineTemplate.wines.sort((a, b) => a.vintage - b.vintage);

      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
}
}
</script>
